<mat-card>
  <mat-card-content class="mb-3">
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" style="height: calc(100vh - 104px);">
        <div class="container">
          <div class="row" style="padding-top: 50px;">
            <div class="col-11 offset-1 text-center">
              <h4>{{'alert.page_not_found_no_access' | translate}}</h4>
              <h4>
                {{'alert.back_home_no_access' | translate}}
              </h4>
              <button mat-stroked-button color="primary" type="button" (click)="goBack()">
                <mat-icon class="mr-0">arrow_back</mat-icon>
                {{ 'alert.back_history' | translate }}
              </button>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-card-content>
</mat-card>
